const template = require('./client_profile_changes_detail_panel.slim')
declare var angular

export class ClientProfileChangesDetailPanel {
  static $inject = ['$scope']

  properties

  constructor(private $scope) {
    this.properties = $scope.properties
  }

  public shouldDisplayArray(value): boolean {
    return this.isArray(value)
  }

  public shouldDisplayObject(value): boolean {
    return this.isObject(value) && !this.isArray(value)
  }

  public shouldDisplayAnythingElse(value): boolean {
    return !this.isObject(value) && !this.isArray(value)
  }


  public isObject(value): boolean {
    var potentialObject = this.properties[value]
    return potentialObject instanceof Object
  }

  public isArray(value): boolean {
    var potentialArray = this.properties[value]
    return potentialArray instanceof Array
  }

  /**
   * Format client profile change values to a human readable format
   *
   * @param {any} value
   * @returns {string}
   *
   * @memberOf ClientProfileChangesDetailPanel
   */
  public formatToHumanReadable(value): string {
    var formattedValue = ''
    if (typeof value === 'boolean') {
      if (value) { formattedValue = 'Yes' } else { formattedValue = 'No' }
    } else if (value === null || value === undefined || value === {} || value === []) {
      formattedValue = "N/A"
    } else {
      formattedValue = value
    }
    return formattedValue
  }
}

angular.module('wbComponents').directive('clientProfileChangesDetailPanel', function() {
  return {
    restrict: 'E',
    templateUrl: template,
    controller: ClientProfileChangesDetailPanel,
    controllerAs: 'ctrl',
    bindToController: true,
    replace: true,
    scope: {
      properties: '=',
      changes: '=',
      title: '@',
    },
  }
})
